export class DatosSobre {
    idDocumentoSobre: number;
    idPaisDocumentoSobre: number;
    tipoDocumento: string;
    visualizador: string;
    formato: string;
}